<div
  #avatar
  class="palantir-avatar"
  [ngClass]="['palantir-avatar--shape-' + shape, 'palantir-avatar--size-' + size]"
>
  <ng-content />
</div>
